if (!customElements.get('length-picker')) {
  customElements.define(
    'length-picker',
    class LengthPicker extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="number"]');
        this.btnMinus = this.querySelector('[data-length-btn="minus"]');
        this.btnPlus = this.querySelector('[data-length-btn="plus"]');
        this.qtyHidden = this.querySelector('[data-length-qty]');
        this.propHidden = this.querySelector('[data-length-prop]');
        this.unitPriceEl = this.querySelector('[data-length-unit-price]');
        this.totalExEl = this.querySelector('[data-length-total-ex]');
        this.totalIncEl = this.querySelector('[data-length-total-inc]');

        this.minLength = parseFloat(this.dataset.minLength) || 0.1;
        this.stepSize = parseFloat(this.dataset.step) || 0.1;
        this.perMetre = this.dataset.perMetre !== 'false';
        this.variantPricePence = parseInt(this.dataset.variantPrice, 10) || 0;
        // Per-order maximum length (metres). max-units are 0.1m cart units, so
        // 149 units = 14.9m. 0/absent => no cap (Infinity).
        this.maxUnits = parseInt(this.dataset.maxUnits, 10) || 0;
        this.maxLength = this.maxUnits > 0 ? this.maxUnits / 10 : Infinity;
        this.maxMsgEl = this.querySelector('[data-length-max-msg]');
        this.phone = '01392 927729';
        this.vatRate = 1.20;
        this.currencyFmt = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'GBP',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }

      connectedCallback() {
        this.input.addEventListener('input', () => this.update());
        this.input.addEventListener('change', () => this.normalise());
        this.btnMinus.addEventListener('click', () => this.bump(-1));
        this.btnPlus.addEventListener('click', () => this.bump(+1));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event?.data?.variant;
            if (!variant) return;
            if (event.data.sectionId && event.data.sectionId !== this.dataset.sectionId) return;
            this.variantPricePence = variant.price;
            this.update();
          });
        }

        this.update();
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      // Returns price per 0.1m in pence, based on whether the variant price is per-metre or per-0.1m.
      unitPricePence() {
        return this.perMetre ? this.variantPricePence / 10 : this.variantPricePence;
      }

      // Returns total in pence for the current length value.
      totalPence(lengthMetres) {
        return Math.round(lengthMetres * 10) * this.unitPricePence();
      }

      bump(direction) {
        const current = parseFloat(this.input.value) || this.minLength;
        let next = Math.max(this.minLength, +(current + direction * this.stepSize).toFixed(2));
        if (next > this.maxLength) next = this.maxLength;
        this.input.value = next.toFixed(1);
        this.update();
      }

      normalise() {
        // Snap to nearest step, enforce the minimum and the per-order maximum on blur.
        let value = parseFloat(this.input.value);
        if (isNaN(value) || value < this.minLength) value = this.minLength;
        const steps = Math.round(value / this.stepSize);
        value = +(steps * this.stepSize).toFixed(2);
        if (value > this.maxLength) value = this.maxLength;
        this.input.value = value.toFixed(1);
        this.update();
      }

      update() {
        const rawMetres = Math.max(this.minLength, parseFloat(this.input.value) || this.minLength);
        // Cap at the per-order maximum so the submitted quantity, the Length note
        // and the displayed total can never exceed what the order will accept.
        const lengthMetres = Math.min(rawMetres, this.maxLength);
        const qtyUnits = Math.round(lengthMetres * 10);

        this.qtyHidden.value = qtyUnits;
        this.propHidden.value = `${lengthMetres.toFixed(1)} m`;

        // Tell the customer when their entry has been clamped to the max, so they
        // never think they're buying more than is going into the basket.
        if (this.maxMsgEl) {
          if (rawMetres > this.maxLength) {
            this.maxMsgEl.textContent = `Maximum ${this.maxLength.toFixed(1)}m per order. For a longer run please call us on ${this.phone} or place a second order.`;
            this.maxMsgEl.hidden = false;
          } else {
            this.maxMsgEl.hidden = true;
          }
        }

        const unitPence = this.unitPricePence();
        const perMetrePence = this.perMetre ? this.variantPricePence : this.variantPricePence * 10;
        const totalPence = qtyUnits * unitPence;

        if (this.unitPriceEl) {
          this.unitPriceEl.textContent = this.currencyFmt.format((perMetrePence / this.vatRate) / 100);
        }
        if (this.totalExEl) {
          this.totalExEl.textContent = this.currencyFmt.format((totalPence / this.vatRate) / 100);
        }
        if (this.totalIncEl) {
          this.totalIncEl.textContent = this.currencyFmt.format(totalPence / 100);
        }
      }
    }
  );
}
